import type {ConnectElementConfig} from '../ConnectElementList';

export const RecipientOnboardingConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "globalPayoutsRecipientOnboarding" */ '../../../components/GlobalPayouts/RecipientOnboarding'
    ),
  teamOwner: 'payouts-surfaces',
  sentryTeam: 'recipient_payouts',
  releaseState: 'internal',
  description: 'Collect onboarding information for Global Payouts recipients.',
  friendlyName: 'Global Payouts Recipient Onboarding',
  requiresAuthentication: true,
  enableV2APIToken: true,
};
